module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row columns"
  }, [_c('div', {
    staticClass: "panel-content"
  }, [_c('div', {
    staticClass: "row small-up-1 medium-up-2 large-up-6"
  }, _vm._l((_vm.currentItems), function(asset) {
    return _c('div', {
      staticClass: "columns"
    }, [_c('img', {
      staticClass: "thumbnail clear",
      attrs: {
        "id": asset.name,
        "src": asset.url,
        "alt": "aperçu"
      },
      on: {
        "click": _vm.onImageClicked
      }
    })])
  }), 0)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row columns"
  }, [_c('div', {
    staticClass: "large-10 large-centered"
  }), _vm._v(" "), _c('paginate', {
    attrs: {
      "click-handler": _vm.paginateClickCallback,
      "prev-text": 'Prev',
      "next-text": 'Next',
      "page-count": _vm.getPageCount,
      "container-class": 'pagination'
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bf9cff8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/image-editor/image-library.vue
// module id = 716
// module chunks = 0